import { render, staticRenderFns } from "./kuaishouPlaybackDetails.vue?vue&type=template&id=07bba464&"
import script from "./kuaishouPlaybackDetails.vue?vue&type=script&lang=js&"
export * from "./kuaishouPlaybackDetails.vue?vue&type=script&lang=js&"
import style0 from "./kuaishouPlaybackDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports